import { Box, FormControl, InputLabel, Menu, Typography } from "@mui/material";
import React from "react";
import LOGO from  "../public/Logo.png"
import { useNavigate } from "react-router-dom";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useState } from "react";

export const Navigation = (props) => {
  const navigate = useNavigate()
  const width = window.innerWidth <= 768 
  const [open, setOpen] = useState(false);
  const handleMouseLeave = () => {
    setTimeout(() => setOpen(false), 10); // Short delay to prevent flickering
  };
  const CustomIcon = () => {
    return (
      <ArrowDropDownIcon  
        sx={{ 
          color: 'white', 
          fontSize: '1.75rem',
          marginLeft:"-2.5rem",
          marginTop:"-1rem" ,
        }} 
      />
    );
  };
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top"  style={{maxWidth:"100%"}}>
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Box sx={{width:50 ,display:"flex",alignItems:"center",flexWrap:"nowrap",gap:1, cursor:"pointer"}} onClick= {() => navigate('/')}>
             
            <Box
                sx={{ bgcolor: "#fff", width: 50, borderRadius: 10, mr:1 ,marginLeft: {xs: 1, sm: 1,  md: 0,}}}
                >
                <img src={LOGO} style={{ width: 50 }} alt="Logo" />
            </Box>
            <Typography variant="h3" sx={{textWrap:"nowrap" ,fontSize:"2.5rem", fontWeight:"bold", }} className="logoHeading">Elite <span style={{ color: "#009bd6" }}>Engineering</span></Typography>
          </Box>
        
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
          <li>
              <a href="/" >
                Home
              </a>
            </li>
            
            <li>
              <a href="/about" >
                About Us
              </a>
            </li>
             <li>
              <a>
               
              <FormControl variant="standard">
                <Select
                  displayEmpty
                  disableUnderline
                  defaultValue={"Option 1"}
                  open={open}
                  onMouseEnter={() => setOpen(true)}  // Show dropdown on hover over Select
                  onMouseLeave={() => setOpen(false)} // Hide dropdown when hover is removed
                  IconComponent={CustomIcon}
                  sx={{
                    '& .MuiSelect-select': {
                      fontSize: '1.5rem', // Increase the text size
                      paddingTop: "4px",  // Remove padding
                    },
                    '&:before, &:after': {
                      border: 'none',  // Remove default underline
                    },
                  }}
                  style={{ color: "white" }}
                  MenuProps={{
                    PaperProps: {
                      onMouseLeave: () => setOpen(false), // Ensure dropdown closes when mouse leaves menu area
                    }
                  }}
                >
                  <MenuItem
                    value="Option 1"
                    onClick={() => navigate("/services")}
                    style={{ fontSize: "1.75rem", margin: "1rem" }}
                  >
                    Our Services
                  </MenuItem>
                  <MenuItem
                    value="Option 2"
                    onClick={() => navigate("/supply")}
                    style={{ fontSize: "1.75rem", margin: "1rem" }}
                  >
                    Supply
                  </MenuItem>
                </Select>
              </FormControl>
              </a>
             </li>
            <li>
              <a href="/portfolio" >
               Our Projects
              </a>
            </li>
            <li>
              <a href="/contact-us" >
              Contact Us
              </a>
            </li>
            
         
          </ul>
        </div>
      </div>
    </nav>
  );
};
